import CheckIcon from "@untitled-ui/icons-react/build/esm/Check";
import { Tag } from "antd";

const TabLabel = ({
  number,
  label,
  isLast,
  activeTab,
  setActivePage,
  modifiedPages,
}) => {
  const isActive = activeTab === number;
  const isChecked = number < activeTab;
  const hasModified = modifiedPages?.find((item) => item === number);
  return (
    <div
      onClick={() => isChecked && setActivePage(number)}
      style={{
        display: "flex",
        // alignItems: "center",
        position: "relative",
      }}
    >
      <div
        style={{
          display: "grid",
          alignItems: "center",
          justifyContent: "center",
          paddingInline: 5,
        }}
      >
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            background: isActive
              ? "#FDF4FF"
              : isChecked
              ? "#ECFDF3"
              : "#F9FAFB",
            border: isActive
              ? "1px solid #F6D0FE "
              : isChecked
              ? "1px solid #ABEFC6"
              : "1px solid #EAECF0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: isActive ? "#9F1AB1" : "#344054",
            fontSize: "14px",
            fontWeight: "400",
            // marginRight: "12px",
            zIndex: 10,
          }}
        >
          {isChecked ? <CheckIcon width={12} color="#079455" /> : number}
        </div>
        {!isLast && (
          <div
            style={{
              position: "relative",
              // left: "14px",
              top: "8px",
              // bottom: "32px",
              width: "1px",
              height: "70px",
              background: "#E5E7EB",
              zIndex: 1,
              marginInline: "auto",
            }}
          />
        )}
      </div>
      <div
        style={{
          height: "100%",
          position: "relative",
          top: hasModified ? -8 : 4,
          left: 10,
          display: "grid",
          justifyItems: "start",
        }}
      >
        <div
          style={{
            color: isActive ? "#9F1AB1" : "#344054",
            fontWeight: "600",
          }}
        >
          {label}
        </div>
        {hasModified && (
          <Tag
            style={{
              color: "#B54708",
              backgroundColor: "#FFFAEB",
              borderColor: "#FEDF89",
              borderRadius: 9999,
              paddingInline: 10,
              marginTop: 5,
              fontWeight: 500,
              // paddingBlock: 1,
            }}
          >
            Changes made
          </Tag>
        )}
      </div>
    </div>
  );
};

export default TabLabel;
